import { all, call, put, takeLatest } from 'redux-saga/effects';

import { fetchEncodedData } from '../../../utility/requests';

import actionCreators from './actionCreators';
import actionTypes from './actionTypes';

function* milestones({ gameTypeId }) {
    try {
        const [
            goalieGamesPlayed,
            goalieMinutesPlayed,
            goalieShutouts,
            goalieWins,
            skaterGamesPlayed,
            skaterGoals,
            skaterAssists,
            skaterPoints,
        ] = yield all([
            call(
                fetchEncodedData,
                `${window.__BASE_REST_URL__}/milestones/goalies?cayenneExp=milestone='Games Played' and gameTypeId=${gameTypeId}`,
            ),
            call(
                fetchEncodedData,
                `${window.__BASE_REST_URL__}/milestones/goalies?cayenneExp=milestone='Minutes Played' and gameTypeId=${gameTypeId}`,
            ),
            call(
                fetchEncodedData,
                `${window.__BASE_REST_URL__}/milestones/goalies?cayenneExp=milestone='Shutouts' and gameTypeId=${gameTypeId}`,
            ),
            call(
                fetchEncodedData,
                `${window.__BASE_REST_URL__}/milestones/goalies?cayenneExp=milestone='Wins' and gameTypeId=${gameTypeId}`,
            ),
            call(
                fetchEncodedData,
                `${window.__BASE_REST_URL__}/milestones/skaters?cayenneExp=milestone='Games Played' and gameTypeId=${gameTypeId}`,
            ),
            call(
                fetchEncodedData,
                `${window.__BASE_REST_URL__}/milestones/skaters?cayenneExp=milestone='Goals' and gameTypeId=${gameTypeId}`,
            ),
            call(
                fetchEncodedData,
                `${window.__BASE_REST_URL__}/milestones/skaters?cayenneExp=milestone='Assists' and gameTypeId=${gameTypeId}`,
            ),
            call(
                fetchEncodedData,
                `${window.__BASE_REST_URL__}/milestones/skaters?cayenneExp=milestone='Points' and gameTypeId=${gameTypeId}`,
            ),
        ]);

        const allMilestones = {
            goalieGamesPlayed,
            goalieMinutesPlayed,
            goalieShutouts,
            goalieWins,
            skaterGamesPlayed,
            skaterGoals,
            skaterAssists,
            skaterPoints,
        };

        yield put(actionCreators.milestonesResponse(true, null, allMilestones));
    } catch (errors) {
        yield put(actionCreators.milestonesResponse(false, errors, null));
    }
}

export default function* watchMilestones() {
    yield takeLatest(actionTypes.REQUEST_MILESTONES, milestones);
}
